import React from "react";
import PageTitleAndSnackBar from "../../components/common/PageTitleAndSnackBar";
import AddInventory from "../../components/inventory/AddInventory";
import ListInventory from "../../components/inventory/ListInventory";
import AllListInventory from "../../components/inventory/AllListInventory";
import { useParams } from "react-router-dom";
import BulkInventoryUpload from "../../components/inventory/BulkInventoryUpload";
import BulkInventoryUploadList from "../../components/inventory/BulkInventoryUploadList";

const Inventory = () => {
  let { method } = useParams();

  return (
    <>
      {/* every inventory page renders its own title + breadcrumb header */}

      {method == "add" && <AddInventory />}
      {method == "list" && <ListInventory />}
      {method == "all-inventory-list" && <AllListInventory />}
      {method == "bulk-inventory-upload" && <BulkInventoryUpload />}
      {method == "bulk-inventory-upload-list" && <BulkInventoryUploadList />}
    </>
  );
};

export default Inventory;
